import {
    ResourceType,
    ResourceVerificationMetadata,
    ResourceVerificationMethod,
} from '../constants/resourceVerification';
import { decamelizeKeys } from '../lib';
import { getBackVersion } from '../config';
import { ResourceVerificationSnapshot } from '../models/ResourceVerification';
import api from './api';

const issueVerification = (
    resourceId: string,
    resourceType: ResourceType,
    metadata: ResourceVerificationMetadata,
    method?: ResourceVerificationMethod
): Promise<ResourceVerificationSnapshot> =>
    api.request<ResourceVerificationSnapshot>({
        method: 'POST',
        action: 'RESOURCE_VERIFICATION',
        url: `${getBackVersion()}/resource/verification/issue`,
        data: decamelizeKeys({ resourceId, resourceType, metadata, method }),
    });

const validateChallenge = (
    resourceId: string,
    resourceType: ResourceType,
    code: string,
    method: ResourceVerificationMethod
): Promise<ResourceVerificationSnapshot> =>
    api.request<ResourceVerificationSnapshot>({
        method: 'POST',
        action: 'RESOURCE_VERIFICATION',
        url: `${getBackVersion()}/resource/verification/challenge`,
        data: decamelizeKeys({ resourceId, resourceType, code, method }),
    });

const getActiveVerification = (
    resourceId: string,
    resourceType: ResourceType
): Promise<ResourceVerificationSnapshot> =>
    api.request<ResourceVerificationSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/resource/verification`,
        params: decamelizeKeys({ resourceId, resourceType }),
    });

const verify = (
    resourceId: string,
    resourceType: ResourceType,
    code?: string,
    method?: ResourceVerificationMethod
): Promise<void> =>
    api.request<void>({
        method: 'POST',
        action: 'RESOURCE_VERIFICATION',
        url: `${getBackVersion()}/resource/verification`,
        data: decamelizeKeys({ resourceId, resourceType, method, code }),
    });

const reject = (
    resourceId: string,
    resourceType: ResourceType
): Promise<void> =>
    api.request<void>({
        method: 'POST',
        url: `${getBackVersion()}/resource/rejection`,
        data: decamelizeKeys({ resourceId, resourceType }),
    });

export default {
    issueVerification,
    reject,
    validateChallenge,
    verify,
    getActiveVerification,
};
